import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../utils/Constants";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: token,
    },
  };
};

export const generateTagsAPI = createAsyncThunk(
  "tags/generateTags",
  async ({ technology, skill, body }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/generate-tags`,
        { technology, skill, body },
        {
          ...getAuthHeader(),
        }
      );

      return response.data;

    } catch (error) {
      if (error.response?.status === 400) {
        return {
          isTechnical: false,
          message: error.response.data.message,
        };
      }
      return rejectWithValue(
        error.response?.data?.message || "Failed to generate tags"
      );
    }
  }
);

const tagSlice = createSlice({
  name: "tags",
  initialState: {
    generatedTags: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetTags: (state) => {
      state.generatedTags = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateTagsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateTagsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.generatedTags = action.payload;

        if (action.payload.isTechnical === false) {
          state.generatedTags = [];
          state.error = action.payload.message;
        } else {
          state.generatedTags = action.payload.tags;
          state.error = null;
        }
      })
      .addCase(generateTagsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTags } = tagSlice.actions;
export default tagSlice.reducer;